import React from "react";

var LayoutSimple = function LayoutSimple(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return React.createElement("main", {
    className: "l-main l-main--page"
  }, React.createElement("h2", {
    className: "l-page-name t-display-2"
  }, title), React.createElement("div", {
    className: "l-content"
  }, children));
};

export default LayoutSimple;